<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'App',

}
</script>

<style >
html,
body,
h3,
p {
  margin: 0;
  padding: 0;
}

/* flex居中 */
.flex-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
